// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * NextWork API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValidationStatus } from './validationStatus';
import {
    ValidationStatusFromJSON,
    ValidationStatusFromJSONTyped,
    ValidationStatusToJSON,
    ValidationStatusToJSONTyped,
} from './validationStatus';

/**
 * 
 * @export
 * @interface ValidationBox
 */
export interface ValidationBox {
    /**
     * 
     * @type {string}
     * @memberof ValidationBox
     */
    id?: string;
    /**
     * 
     * @type {ValidationStatus}
     * @memberof ValidationBox
     */
    status?: ValidationStatus;
}



/**
 * Check if a given object implements the ValidationBox interface.
 */
export function instanceOfValidationBox(value: object): value is ValidationBox {
    return true;
}

export function ValidationBoxFromJSON(json: any): ValidationBox {
    return ValidationBoxFromJSONTyped(json, false);
}

export function ValidationBoxFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidationBox {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'] == null ? undefined : ValidationStatusFromJSON(json['status']),
    };
}

export function ValidationBoxToJSON(json: any): ValidationBox {
    return ValidationBoxToJSONTyped(json, false);
}

export function ValidationBoxToJSONTyped(value?: ValidationBox | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': ValidationStatusToJSON(value['status']),
    };
}

